import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAlbumsList = loadable(() => import(/* webpackChunkName: "content/guest/mediacollection/albumlist" */ './AlbumsList'), 'AlbumsList');
